/**
 * Секция загрузки справочников
 */

import React from 'react';
import { FileUploadFormComponent } from '../forms/FileUploadForm';
import {
  useUploadAverageIncome,
  useUploadFullCost,
  useUploadPointsOfSale,
  useUploadPskMapping,
  useUpload9FZRegistry,
} from '../../../hooks/useAdmin';
import { averageIncomeUploadSchema } from '../validation/schemas';

/**
 * Компонент секции "Загрузка справочников"
 */
export const ReferencesSection: React.FC = () => {
  const uploadAverageIncomeMutation = useUploadAverageIncome();
  const uploadFullCostMutation = useUploadFullCost();
  const uploadPointsOfSaleMutation = useUploadPointsOfSale();
  const uploadPskMappingMutation = useUploadPskMapping();
  const upload9FZRegistryMutation = useUpload9FZRegistry();

  return (
    <div>
      <FileUploadFormComponent
        title="Данные по среднедушевому доходу"
        fileId="averageIncome"
        onSubmit={async (formData) => {
          await uploadAverageIncomeMutation.mutateAsync(formData);
        }}
        isLoading={uploadAverageIncomeMutation.isPending}
        hasExtraFields={true}
        validationSchema={averageIncomeUploadSchema}
      />

      <FileUploadFormComponent
        title="Данные по среднерыночному значению ПСК"
        fileId="fullCost"
        onSubmit={async (formData) => {
          await uploadFullCostMutation.mutateAsync(formData);
        }}
        isLoading={uploadFullCostMutation.isPending}
      />

      <FileUploadFormComponent
        title="Данные по точкам продаж"
        fileId="pointOfSale"
        onSubmit={async (formData) => {
          await uploadPointsOfSaleMutation.mutateAsync(formData);
        }}
        isLoading={uploadPointsOfSaleMutation.isPending}
      />

      <FileUploadFormComponent
        title="Меппинг ПСК"
        fileId="dealTypeMapping"
        onSubmit={async (formData) => {
          await uploadPskMappingMutation.mutateAsync(formData);
        }}
        isLoading={uploadPskMappingMutation.isPending}
      />

      <FileUploadFormComponent
        title="Реестр ЦБ по 9-ФЗ"
        fileId="registry9fz"
        onSubmit={async (formData) => {
          await upload9FZRegistryMutation.mutateAsync(formData);
        }}
        isLoading={upload9FZRegistryMutation.isPending}
      />
    </div>
  );
};
